import { all, call, fork, put, select, takeLatest, takeEvery } from "redux-saga/effects";
import { isEmpty } from "lodash";

import { usersApiUpsellProvider } from "../../lib/api/providers";
import { GET_USERS_SECTORS_LIST, SET_USERS_SECTORS_LIST } from "../types";

const getUsersSectorsListApi = (endpoint, token, params) => {
  const filters = isEmpty(params) ? { sort: { date: -1 } } : { ...params, sort: { date: -1 } };

  return endpoint
    .post(`/`, filters, {
      headers: {
        Authorization: token
      }
    })

    .then((response = {}) => {
      return response.data;
    });
};

const getAuthState = state => state.auth || {};

export function* getUserSectorsListFunction(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(getUsersSectorsListApi, usersApiUpsellProvider, stateAuth.token, action.payload);

    if (values) {
      yield put({
        type: SET_USERS_SECTORS_LIST,
        payload: values
      });
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* watchFetchUsersSectorsList() {
  yield takeEvery(GET_USERS_SECTORS_LIST, getUserSectorsListFunction);
}

export default function* root() {
  yield all([fork(watchFetchUsersSectorsList)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/usersSectorsSagas.js